import { memo } from "react";
import {
  Card,
  CardContent,
  CardFooter,
  CardHeader,
} from "@cointervue/design-system";

// Reusable skeleton block
const Skeleton = ({ className }: { className: string }) => (
  <div className={`bg-brand-gray-light rounded ${className}`} />
);

function PreInterviewScreenSkeleton() {
  return (
    <div className="h-full w-full flex-center flex-col animate-pulse">
      {/* Logo */}
      <Skeleton className="w-36 h-10 mb-4" />

      <Card className="w-full max-w-md rounded-2xl shadow-lg space-y-2">
        {/* Header */}
        <CardHeader className="flex-center flex-col text-center space-y-3 p-3">
          <Skeleton className="w-48 h-6" />
          <Skeleton className="w-64 h-4" />
          <Skeleton className="w-28 h-6 rounded-full" />
          <Skeleton className="w-40 h-3" />

          <div className="space-y-2 flex flex-col items-center">
            <Skeleton className="w-72 h-3" />
            <Skeleton className="w-60 h-3" />
          </div>

          <Skeleton className="w-52 h-3" />
        </CardHeader>

        {/* Content */}
        <CardContent className="space-y-3 my-1">
          <Skeleton className="w-full h-14 rounded-lg" />

          <div className="space-y-2">
            {[...Array(3)].map((_, i) => (
              <Skeleton key={i} className="w-full h-10 rounded-lg" />
            ))}
          </div>
        </CardContent>

        {/* Footer */}
        <CardFooter className="flex-col space-y-3">
          <Skeleton className="w-full h-10 rounded-lg" />
          <Skeleton className="w-40 h-3" />
        </CardFooter>
      </Card>
    </div>
  );
}

export default memo(PreInterviewScreenSkeleton);